import { Label } from '@fluentui/react';
import { connect } from 'react-redux';
import Text from 'src/components/text/Text';
import localeService from 'src/dataServices/LocaleService';
import { getLocalizedOrganizationTypeText } from './ProfileSharedFunctions';
import { IApplicationState } from 'src/state';
import { IFeatureFlagsState } from 'src/state/feature-flags';
import { IProfile } from 'src/state/profile/types';
import './OrgInfoSection.scss';
import './ProfileForm.scss';
import RegistrationIdentifiersView from './RegistrationIdentifiersView';

interface IPropsFromState {
  featureFlags: IFeatureFlagsState;
}

interface IPropsFromParent {
  profile: IProfile;
}

export type IProfileProps = IPropsFromParent & IPropsFromState;

const renderField = (
  labelCategory: string,
  labelId: string,
  fieldName: string,
  fieldValue: string,
  prefix?: string
) => {
  return (
    <div>
      <Label tabIndex={-1} htmlFor={fieldName}>
        <Text category={labelCategory} id={labelId} />
      </Label>
      {fieldValue && (
        <p className="org-info-text">
          <b>
            {prefix}
            {fieldValue}
          </b>
        </p>
      )}
    </div>
  );
};

const OrgInfoSection2View = ({ profile, featureFlags }: IProfileProps): JSX.Element => {
  return (
    <div id="org-info">
      <div id="profile-org-info-description">
        <p>{localeService.getText('ProfileV2', 'OrgInformationDescription')}</p>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('ProfileV2', 'OrganizationName', 'name', profile.name)}
        </div>
        {featureFlags.profilePageEnhancementsEnabled && (
          <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
            {renderField(
              'ProfileV2',
              'OrganizationType',
              'organizationType',
              getLocalizedOrganizationTypeText(profile.organizationType)
            )}
          </div>
        )}
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('ProfileV2', 'StreetAddress1', 'address.addressLine1', profile.address.addressLine1)}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('ProfileV2', 'StreetAddress2', 'address.addressOther', profile.address.addressOther)}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('Profile', 'City', 'address.city', profile.address.city)}
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('Profile', 'State', 'address.stateRegion', profile.address.stateRegion)}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('Profile', 'Postcode', 'address.postalCode', profile.address.postalCode)}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('Profile', 'Country', 'address.country', profile.address.country)}
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('Profile', 'Website', 'websiteUrl', profile.websiteUrl)}
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md4 ms-lg4 ms-xl4">
          {renderField('ProfileV2', 'PhoneNumber', 'address.phone', profile.address.phone)}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ flags }: IApplicationState) => ({
  featureFlags: flags
});

export default connect(mapStateToProps)(OrgInfoSection2View);
